document.addEventListener("DOMContentLoaded", () => {

  const customButton = document.querySelector(".matching-add-to-cart");

  if (!customButton) return;

  function updateActiveState() {
    const checkedProducts = document.querySelectorAll(
      ".matching-product__checkbox-input:checked"
    );

    if (checkedProducts.length > 0) {
      customButton.classList.add("active");
     customButton.removeAttribute("disabled");
    } else {
      customButton.classList.remove("active");
      customButton.setAttribute("disabled", "disabled");
    }
  }

  // ====================================
  // UPDATE CUSTOM BUTTON
  // ====================================
  function updateCustomButton() {
    if (!customButton.classList.contains("active")) return;

    const mainButton = document.querySelector(".product-form__submit");

    if (!mainButton) return;

    const isDisabled =
      mainButton.disabled ||
      mainButton.hasAttribute("disabled") ||
      mainButton.classList.contains("disabled");

    if (isDisabled) {

      customButton.disabled = true;
      customButton.setAttribute("disabled", "disabled");
      customButton.classList.add("disabled");

    } else {

      customButton.disabled = false;
      customButton.removeAttribute("disabled");
      customButton.classList.remove("disabled");

    }

  }

  document.addEventListener("change", (e) => {
    if (e.target.classList.contains("matching-product__checkbox-input")) {
      updateActiveState();
    }
  });

  // Initial state
  updateCustomButton();

  // ====================================
  // VARIANT CHANGE
  // ====================================
  document.addEventListener("variant:change", () => {

    setTimeout(() => {
      updateActiveState();
      updateCustomButton();
    }, 300);

  });

  // ====================================
  // WATCH MAIN BUTTON CHANGES
  // ====================================
  const mainButton = document.querySelector(".product-form__submit");

  if (mainButton) {

    const observer = new MutationObserver(() => {
      updateCustomButton();
    });

    observer.observe(mainButton, {
      attributes: true,
      attributeFilter: ["disabled", "class"]
    });

  }

  // ====================================
  // CUSTOM ADD TO CART
  // ====================================
  customButton.addEventListener("click", async () => {

    updateCustomButton();

    if (customButton.disabled) return;

    customButton.classList.add("loading");

    try {

      const checkedProducts = document.querySelectorAll(
        ".matching-product__checkbox-input:checked"
      );

      // Add matching products
      for (const checkbox of checkedProducts) {

        const wrapper = checkbox.closest(".matching-product");

        if (!wrapper) continue;

        const variantSelect = wrapper.querySelector(
          ".matching-product__variant"
        );

        if (!variantSelect) continue;

        const variantId = variantSelect.value;

        await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
          }),
        });

      }

      // Trigger main add to cart
      const mainAddButton = document.querySelector('[name="add"]');

      if (mainAddButton && !mainAddButton.disabled) {
        mainAddButton.click();
      }

    } catch (error) {

      console.error("Matching Product Error:", error);

    } finally {

      customButton.classList.remove("loading");

    }

  });

  // ====================================
  // CART REFRESH
  // ====================================
  document.addEventListener("ajaxProduct:added", () => {

    document.dispatchEvent(
      new CustomEvent("cart:refresh")
    );

  });

});

document.querySelectorAll(".matching-product__variant").forEach((select) => {

  function updateVariantPrice() {

    const wrapper = select.closest(".matching-product");

    if (!wrapper) return;

    const priceEl = wrapper.querySelector(".matching-product__price");

    if (!priceEl) return;

    const selectedOption = select.options[select.selectedIndex];

    priceEl.textContent = `+${selectedOption.dataset.price}`;

  }

  // Initial price
  updateVariantPrice();

  // On variant change
  select.addEventListener("change", updateVariantPrice);

});